import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  Typography,
  Grid,
  Tooltip,
  DialogActions,
} from "@mui/material";
import { InfoOutlined } from "@mui/icons-material";

import { Chip, ComponentHeader } from "../../../../components";
import { useAxios } from "../../../../hooks";
import { CancelButton } from "../../../css components/Button";

export default function GovernanceDialog({ dialogState, setDialogState }) {
  const axios = useAxios();
  const [governanceData, setGovernanceData] = useState([]);

  const handleClose = () => {
    setDialogState(false);
  };

  useEffect(() => {
    if (dialogState.state) {
      axios({
        url: "/user/governanceCheck",
        disableRedirect: true,
        method: "POST",
        data: {
          brand_id: dialogState.data.brandID,
        },
      }).then((response) => {
        if (response.status) {
          setGovernanceData(response.data);
        }
      });
    }
  }, [axios, dialogState.data?.brandID, dialogState.state]);

  return (
    <Dialog
      open={dialogState.state}
      onClose={handleClose}
      sx={{ "& .MuiDialog-paper": { minWidth: 400 } }}
    >
      <DialogContent>
        <Grid container spacing={2}>
          <Grid size={12}>
            <ComponentHeader title="Governance Check" />
          </Grid>

          {governanceData.map((gov, index) => (
            <Grid
              item
              xs={12}
              key={index}
              sx={{ display: "flex", gap: 1, alignItems: "center" }}
            >
              <Chip
                label={
                  <Typography fontSize={14}>
                    {gov.gov_check_name}
                    {gov.status_desc && (
                      <Tooltip title={gov.status_desc}>
                        <InfoOutlined
                          fontSize="small"
                          sx={{
                            ml: 0.5,
                            position: "relative",
                            top: 2,
                            cursor: "pointer",
                          }}
                        />
                      </Tooltip>
                    )}
                  </Typography>
                }
                color="#fff"
                background={gov.color}
              />
            </Grid>
          ))}
        </Grid>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <CancelButton onClick={handleClose} variant="outlined">
          Cancel
        </CancelButton>
      </DialogActions>
    </Dialog>
  );
}
